<script>
    import router from '@/router';
    import sessionService from '@/services/session.service';
    import navigationService from '@/services/core/navigation.service';

    export default {
        methods: {
            _goToDefaultRoute() {
                const isLogged = !!sessionService.getToken();
                if (isLogged) this.$router.push(navigationService.getDefaultRoute());
                else {
                    this.$router.push('/auth/login');
                }
            },

            _verifySessionId() {
                const sessionId = decodeURIComponent(router.currentRoute.value.query?.sessionId || '');
                sessionService
                    .varifySession(sessionId)
                    .then(session => {
                        if (session?.sessionToken) {
                            sessionService.setToken(session.sessionToken);
                            router.push(navigationService.getDefaultRoute());
                        }
                    })
                    .catch(() => this._goToDefaultRoute());
            }
        },
        mounted() {
            const action = decodeURIComponent(router.currentRoute.value.query?.action || '');

            switch (action) {
                case 'login':
                    return this._verifySessionId();

                default:
                    return this._goToDefaultRoute();
            }
        }
    };
</script>
<template>
    <div class="text-center pt-5">
        <h2>👋 Welcome!</h2>
        <h5 class="text-muted fw-light">Please wait, we are redirecting you...</h5>
    </div>
</template>
